export function limitAbatement(remainingEmissions: number[], abatementSeries: number[][]): number[][] {
  const result: number[][] = abatementSeries.map((s) => s.concat());
  for (let i = 0; i < remainingEmissions.length; i++) {
    let emissions = remainingEmissions[i];
    if (emissions < 0) {
      for (let j = 0; j < abatementSeries.length; j++) {
        const data = abatementSeries[j][i];
        const adjustedData = Math.max(0, data + emissions);
        emissions += data;
        result[j][i] = adjustedData;
        if (emissions >= 0) {
          break;
        }
      }
    }
  }
  return result;
}
